import React from 'react';
import { Badge, Button, Dialog, Flex, Text } from '@/components/ui';
import { IconClipboardList, IconGitBranch, IconX } from '@tabler/icons-react';
import { StudyForm } from './types';
import { FormFieldsList } from '@/components/data-import/FormFieldsList';

interface FormDetailsModalProps {
  form: StudyForm | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const FormDetailsModal: React.FC<FormDetailsModalProps> = ({
  form,
  open,
  onOpenChange,
}) => {
  if (!form) return null;

  const getFormIcon = () => {
    return form.type === 1 ? <IconClipboardList /> : <IconGitBranch />;
  };

  const getFormTypeLabel = () => {
    if (form.type === 1) {
      return 'Main Form';
    } else {
      return 'Subform';
    }
  };

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content size="large" style={{ maxWidth: '600px' }}>
        <Dialog.Header
          startSlot={getFormIcon()}
          title={form.name}
          subtitle={form.displayName}
          endSlot={
            <Button
              variant="surface"
              size="small"
              isIconOnly
              onClick={() => onOpenChange(false)}
              title="Close"
            >
              <IconX />
            </Button>
          }
        />

        <Dialog.Body>
          <Flex direction="column" gap="4">
            <Flex align="center" gap="3">
              <Badge color="blue" variant="soft">
                {getFormTypeLabel()}
              </Badge>
              <Text size="2" color="gray">
                {form.fieldCount} fields
              </Text>
              {form.parentFormId && (
                <Text size="2" color="gray">
                  Child of {form.parentFormId}
                </Text>
              )}
            </Flex>
          {/* Form Fields */}
          <Flex direction="column" gap="3">
            <Text size="3" weight="medium">
              Form Fields
            </Text>
            <FormFieldsList
              fields={form.fields || []}
              variant="badges"
              maxHeight="300px"
              usePopover={true}
            />
          </Flex>

          {/* Field Details Table */}
          <Flex direction="column" gap="3">
            <Text size="3" weight="medium">
              Field Details
            </Text>
            <FormFieldsList
              fields={form.fields || []}
              variant="table"
              maxHeight="200px"
              usePopover={true}
            />
          </Flex>
          </Flex>
        </Dialog.Body>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default FormDetailsModal;
